import React from 'react';
import PropTypes from 'prop-types';
import withAccountFormStepStyles from 'Components/UI/Accounts/AccountApplication/Step/withAccountFormStepStyles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import Typography from 'Components/UI/Typography';
import { Collapse } from '@mui/material';
import PhoneNumberField from 'Components/UI/Accounts/AccountApplication/Step/Fields/PhoneNumberField';
import { USA } from 'Consts/Apex';

function TrustedContactInformation({ classes }) {
  const { resource } = useMetaLayoutContext();
  const hasTrustedContact = resource.attr('hasTrustedContact') === 'true';

  const hasTrustedContactFieldHidden = resource.meta().field('hasTrustedContact').attr('hidden');

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        { hasTrustedContactFieldHidden
          ? (
            <Typography variant="subtitle1">
              {resource.attr('trustedContactRemovalInformation')}
            </Typography>)
          : <MetaField
            attr="hasTrustedContact"
          />
        }
      </div>
      <Collapse in={hasTrustedContact}>
        <div className={classes.collapseRoot}>
          <div className={classes.row}>
            <Typography
              className={classes.header}
              variant="h3"
              color="primary"
              component={'h2'}
            >
              {'Personal Information'}
            </Typography>
          </div>
          <div className={classes.row}>
            <MetaField attr="trustedContactFirstName" />
            <MetaField attr="trustedContactLastName" />
          </div>
          <Typography
            variant="h4"
            color="primary"
            className={classes.header}
          >
            {'Mailing Address Information'}
          </Typography>
          <div className={classes.row}>
            <MetaField attr="trustedContactAddressLine1" />
          </div>
          <div className={classes.row}>
            <MetaField attr="trustedContactAddressLine2" />
          </div>
          <div className={classes.row}>
            <MetaField attr="trustedContactCity" />
            <MetaField attr="trustedContactState" hidden={resource.attr('trustedContactCountry') !== USA} />
          </div>
          <div className={classes.row}>
            <MetaField attr="trustedContactZipCode" />
            <MetaField attr="trustedContactCountry" />
          </div>
          <Typography
            variant="h4"
            color="primary"
            className={classes.header}
          >
            {'Contact Information'}
          </Typography>
          <div className={classes.row}>
            <PhoneNumberField attr="trustedContactPhoneNumber" />
            <MetaField attr="trustedContactPhoneNumberType" />
          </div>
          <div className={classes.row}>
            <MetaField attr="trustedContactEmail" />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

TrustedContactInformation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withAccountFormStepStyles(TrustedContactInformation);
